export function isFunction(v) {
    return typeof v === 'function';
}
//# sourceMappingURL=is-function.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts-for-react/esm/helper/is-function.js
// module id = 6750
// module chunks = 0